import * as Braze from '@braze/web-sdk';

function getAllBannerPlacementIds (bannerConfig: any) {
  if (!bannerConfig) { return []; }

  const placementIds = [];

  // Handle static frontpage banners
  if (bannerConfig.frontpage?.static) {
    placementIds.push(...Object.values(bannerConfig.frontpage.static)
      .filter((entry: any) => entry.supportedDevices.includes(getDeviceType()))
      .map((entry: any) => entry.id));
  }
  // Handle inline frontpage banners
  if (bannerConfig.frontpage?.inline) {
    placementIds.push(...bannerConfig.frontpage.inline
      .filter((entry: any) => entry.supportedDevices.includes(getDeviceType()))
      .map((entry: any) => entry.id));
  }
  // Handle static article banners
  if (bannerConfig.article?.static) {
    placementIds.push(...Object.values(bannerConfig.article.static)
      .filter((entry: any) => entry.supportedDevices.includes(getDeviceType()))
      .map((entry: any) => entry.id));
  }
  // Handle inline article banners
  if (bannerConfig.article?.inline) {
    placementIds.push(...bannerConfig.article.inline
      .filter((entry: any) => entry.supportedDevices.includes(getDeviceType()))
      .map((entry: any) => entry.id));
  }

  return placementIds;
}

export default function useBrazeBannerCard (braze: typeof Braze, bannerConfig: any) {
  const placementIds = getAllBannerPlacementIds(bannerConfig);

  function subscribeToBannersUpdates () {
    if (placementIds.length <= 0) { return; }
    braze.subscribeToBannersUpdates((banners) => {
      console.log('Braze: Banners', banners);
      Object.entries(banners).forEach(([placementId, banner]) => {
        if (placementIds.includes(placementId)) {
          if (banner) {
            const container = document.getElementById(placementId);
            if (container) {
              braze.insertBanner(banner, container);
              if (banner.isControl) {
                container.style.display = 'none';
              }
            }
          }
        }
      });
    });
  }

  function requestBannersRefresh () {
    if (placementIds.length <= 0) { return; }
    braze.requestBannersRefresh(placementIds);
  }

  return {
    subscribeToBannersUpdates,
    requestBannersRefresh
  };
}
